import "./src/styles/reset.css"
import React, { ReactNode } from "react"
import { AppContextProvider } from "./src/context/Appcontext"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import type { GatsbyBrowser } from "gatsby"

type WrapRootElementProps = {
  element: ReactNode
}

export const wrapRootElement = ({ element }: WrapRootElementProps) => (
  <AppContextProvider>{element}</AppContextProvider>
)

const VERSION = "1"

const applyImageVersioning = () => {
  document.querySelectorAll("img").forEach((img: HTMLImageElement) => {
    if (
      img.src &&
      img.src.includes("media.hindbahwangroup.com") &&
      !img.src.includes("?v=")
    ) {
      img.src = img.src.includes("?")
        ? `${img.src}&v=${VERSION}`
        : `${img.src}?v=${VERSION}`
    }
  })

  document
    .querySelectorAll<HTMLElement>("[style*='background-image']")
    .forEach(el => {
      const bg = el.style.backgroundImage

      if (
        bg &&
        bg.includes("media.hindbahwangroup.com") &&
        !bg.includes("?v=")
      ) {
        el.style.backgroundImage = bg.replace(/url\((.*?)\)/, (_, url) => {
          if (url.includes("?")) return `url(${url}&v=${VERSION})`
          return `url(${url}?v=${VERSION})`
        })
      }
    })
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  if (typeof window !== "undefined" && "caches" in window) {
    window.caches
      .keys()
      .then(names => Promise.all(names.map(name => window.caches.delete(name))))
      .catch(() => {})
  }
}

export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] =
  () => {
    if (typeof window !== "undefined") {
      applyImageVersioning()
      let timeout: any
      const observer = new MutationObserver(() => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          applyImageVersioning()
        }, 100)
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
      const handleChunkError = (errorMessage: string) => {
        if (
          /Loading chunk .* failed/i.test(errorMessage) ||
          /Loading CSS chunk .* failed/i.test(errorMessage) ||
          /Failed to fetch dynamically imported module/i.test(errorMessage)
        ) {
          const hasReloaded = window.sessionStorage.getItem("retry_reload")
          if (!hasReloaded) {
            window.sessionStorage.setItem("retry_reload", "true")
            window.location.reload()
          }
        }
      }

      window.addEventListener("error", (event: ErrorEvent) => {
        handleChunkError(event.message || "")
      })

      window.addEventListener(
        "unhandledrejection",
        (event: PromiseRejectionEvent) => {
          const reason = event.reason
          const message =
            reason instanceof Error ? reason.message : String(reason)
          handleChunkError(message)
        }
      )
    }
  }

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
  if (typeof window !== "undefined") {
    applyImageVersioning()
    window.sessionStorage.removeItem("retry_reload")
  }
}

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0)
  return false
}
